import {injectEndpoints} from '../api/apiSlice';

const extendedApi = injectEndpoints({
  endpoints: (builder) => ({
    getPublicLinkCode: builder.query<string, number>({
      query: (groupId) => `/publicLinkCode/${groupId}`,
      transformResponse(baseQueryReturnValue: {code: string}) {
        return baseQueryReturnValue.code;
      },
    }),
  }),
});

export const {useGetPublicLinkCodeQuery} = extendedApi;
